/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
module.exports = {
    getUrl: function() {
        return 'getusertype';
    },

    getMethod: function() {
        return 'PUT';
    },

    requestSuccess: function(data) {
        Odigeo.trigger(this.widget.id + ':getUserTypeOk', data);
    },

    requestError: function() {
        Odigeo.trigger(this.widget.id + ':getUserTypeFail');
    },
};
